export default "__VITE_ASSET__Kd6zhW4R__"